import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../../../i18n/translate"

export class BooleanProductFilter extends React.Component {
  render() {
    const { productFilter, t } = this.props

    const inputChanged = (ev, group) => {
      group.setValue(ev.target.checked)
    }

    return (
      <>
        <div className="_fp-filter-group__item">
          <input
            className={"_fp-filter-group__item__checkbox"}
            type="checkbox"
            id={productFilter._id}
            checked={productFilter._value}
            onChange={(ev) => inputChanged(ev, productFilter)}
          />
          <label
            className={"_fp-filter-group__item__checkbox__label"}
            htmlFor={productFilter._id}
          >
            {productFilter.name ? t(productFilter.name.key) : ""}
          </label>
        </div>
      </>
    )
  }
}

BooleanProductFilter.propTypes = {
  productFilter: PropTypes.object.isRequired,
}

export default withTranslation()(BooleanProductFilter)
